<template>
  <v-card
    class="stakeholder-card"
    :class="{
      'stakeholder-card--selected': isSelected,
      'stakeholder-card--selectable': isSelectable,
    }"
    :elevation="isSelected ? 4 : 2"
  >
    <v-card-title class="stakeholder-card__title">
      <v-icon left color="contrast">mdi-account-multiple</v-icon>
      {{ stakeholder.name }}
      <v-spacer></v-spacer>
      <v-chip
        v-if="isSelected && isSelectable"
        small
        color="success"
        class="stakeholder-card__chip"
      >
        <div style="display: flex; gap: 4px; align-items: center">
          <div>Selected</div>
          <v-icon color="success" small>mdi-check-circle</v-icon>
        </div>
      </v-chip>
      <v-chip
        v-if="isGPTGenerated"
        small
        color="info"
        class="stakeholder-card__chip"
      >
        AI Generated
        <v-icon small>mdi-robot</v-icon>
      </v-chip>
    </v-card-title>

    <v-card-item class="stakeholder-card__content">
      <div
        v-if="stakeholder.general_description"
        class="detail-row description-row"
      >
        <v-icon small color="contrast">mdi-text</v-icon>
        <span class="detail-text">{{ stakeholder.general_description }}</span>
      </div>

      <div v-if="stakeholder.requirements" class="detail-row">
        <v-icon small color="contrast"
          >mdi-checkbox-multiple-marked-circle</v-icon
        >
        <span class="detail-text">{{ stakeholder.requirements }}</span>
      </div>

      <div v-if="stakeholder.specificities" class="detail-row">
        <v-icon small color="contrast">mdi-star</v-icon>
        <span class="detail-text">{{ stakeholder.specificities }}</span>
      </div>

      <div v-if="stakeholder.related_kpi" class="detail-row">
        <v-icon small color="contrast">mdi-target</v-icon>
        <span class="detail-text">{{ stakeholder.related_kpi }}</span>
      </div>

      <div
        v-if="
          !stakeholder.general_description &&
          !stakeholder.requirements &&
          !stakeholder.specificities
        "
        class="detail-row no-details"
      >
        <v-icon small color="contrast">mdi-information-outline</v-icon>
        <span class="detail-text">No details available</span>
      </div>
    </v-card-item>

    <v-spacer></v-spacer>

    <!-- Card actions -->
    <v-card-actions class="stakeholder-card__actions">
      <v-spacer></v-spacer>
      <v-btn
        v-if="!isSelectable && stakeholder.isEditable !== false"
        color="primary"
        @click="handleEdit"
      >
        <v-icon>mdi-pencil</v-icon>
        Edit
      </v-btn>
      <v-btn v-if="!isSelectable" color="error" @click="handleDelete">
        <v-icon>mdi-delete</v-icon>
        Remove
      </v-btn>
      <v-btn
        v-if="isSelectable"
        :color="isSelected ? 'error' : 'primary'"
        text
        @click="handleClick"
      >
        <v-icon left>
          {{ isSelected ? "mdi-close-circle" : "mdi-check-circle" }}
        </v-icon>
        {{ isSelected ? "Unselect" : "Select" }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "StakeholderCard",

  props: {
    stakeholder: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["toggle", "delete", "edit"],

  computed: {
    isGPTGenerated() {
      return (
        this.stakeholder.specificities === "Stakeholder generated with GPT"
      );
    },
  },

  methods: {
    handleClick() {
      this.$emit("toggle", this.stakeholder);
    },

    handleDelete() {
      this.$emit("delete", this.stakeholder.id);
    },

    handleEdit() {
      this.$emit("edit", this.stakeholder);
    },
  },
};
</script>

<style scoped>
.stakeholder-card {
  margin: 8px;
  transition: all 0.2s ease;
  position: relative;
  background-color: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid transparent !important;
}

.stakeholder-card__title {
  font-weight: bold;
  font-size: 1.2em;
  color: var(--contrastColor) !important;
  padding-bottom: 4px;
  white-space: wrap;
}

.stakeholder-card__content {
  padding-top: 0;
}

.stakeholder-card__chip {
  margin-left: 8px;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 6px;
}

.detail-row .v-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.detail-text {
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--contrastColor) !important;
  word-break: break-word;
}

.description-row {
  font-style: italic;
  white-space: pre-wrap;
}

.no-details {
  font-style: italic;
  display: flex;
  align-items: center;
  padding-left: 5px;
}

.stakeholder-card--selected {
  border: 1px solid var(--contrastColor) !important;
}
</style>
